import * as React from "react";

import { stripToWeek } from "../utils/date";

import { Day } from "./Day";

export interface IWeekProps extends React.Props<Week> {
    day: Date;
    endDate?: Date;
    excludeDates?: Date[];
    filterDate?: (d: Date) => boolean;
    maxDate?: Date;
    minDate?: Date;
    month?: number;
    onDayClick?: (d: Date) => void;
    selected?: Date;
    startDate?: Date;
}

export class Week extends React.Component<IWeekProps, any> {
    public render(): JSX.Element {
        return <tr className="week-row">{this.renderDays()}</tr>;
    }
    private handleDayClick(day: Date): void {
        if (this.props.onDayClick) {
            this.props.onDayClick(day);
        }
    }

    private renderDays(): JSX.Element[] {
        const startOfWeek = stripToWeek(this.props.day);
        return [0, 1, 2, 3, 4, 5, 6].map((offset: number) => {
            const day = new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate() + offset);
            const isOutside = this.props.month !== undefined && this.props.month !== day.getMonth();
            return (
                <td aria-hidden={isOutside} key={offset}>
                    <Day
                        day={day}
                        month={this.props.month}
                        onDayClick={(d: Date) => this.handleDayClick(d)}
                        minDate={this.props.minDate}
                        maxDate={this.props.maxDate}
                        excludeDates={this.props.excludeDates}
                        filterDate={this.props.filterDate}
                        selected={this.props.selected}
                        startDate={this.props.startDate}
                        endDate={this.props.endDate}
                        notTabbable={isOutside}
                    />
                </td>
            );
        });
    }
}
